<script lang="ts" setup>
  export type Element =
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'p'
    | 'span'
    | 'li'
    | 'td'
  export type Variant =
    `text-${'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | `[${number}px]`}`
  export type Weight =
    `font-${'normal' | 'medium' | 'semibold' | 'bold' | 'extrabold' | 'black'}`

  export interface TypographyProps {
    element?: Element
    variant?: Variant
    weight?: Weight
    color?: string
    lineHeight?: string
    htmlContent?: string
    classes?: string
  }
  withDefaults(defineProps<TypographyProps>(), {
    element: 'p',
    variant: 'text-base',
    weight: 'font-normal',
    color: 'text-black',
    lineHeight: '',
    htmlContent: '',
    classes: '',
  })
</script>
<template>
  <component
    :is="element"
    v-if="htmlContent"
    :class="[variant, weight, color, lineHeight]"
  >
    <div v-dompurify-html="htmlContent" />
  </component>
  <component
    :is="element"
    v-else
    :class="[variant, weight, color, lineHeight, classes]"
  >
    <slot />
  </component>
</template>
